<button class="cursor-pointer bg-secondary transition-colors hover:bg-secondary-hover px-5 py-2 rounded text-center drop-shadow-lg w-full">
  <fa-icon *ngIf="_icon" [icon]="_icon" class="pr-1.5"></fa-icon>
  {{_text}}
</button>
